import * as types from './mutation_types'

export const setFilter = ({ commit }, filter) => commit(types.SET_FILTER, filter)
export const toggleShowFilter = ({ commit }) => commit(types.TOGGLE_SHOW_FILTER)
export const resetState = ({ commit }) => commit(types.RESET_STATE)
